<template>
  <form class="form-horizontal">
    <div class="page-header">
      <span class="glyphicon glyphicon-paperclip"></span>
      三级页面视频
    </div>
    <div class="form-group d-flex">
      <div class="col-xs-6">
        <div>
          视频封面图片
          <button type="button" class="close" @click="removeVideoCoverPath">&times;</button>
        </div>
        <div class="media l-media">
          <div class="media-left l-media-left">
            <d-upload
              :url.sync="route.basic.videoCoverPath"
              class="btn btn-primary btn-block btn-xs"
              style="width: 260px;"
            >上传图片 16:9</d-upload>
            <img
              class="img-responsive"
              style="width: 260px;"
              v-show="route.basic.videoCoverPath"
              :src="route.basic.videoCoverPath"
            />
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <div>视频识别码</div>
        <div class="media l-media">
          <div class="media-body">
            <input class="form-control" v-model="route.basic.videoId" placeholder="请输入视频识别码" />
            <div style="margin-top: 10px;">
              * 请去
              <a :href="xmenProductUrl + '/uploadVideo/index'" target="_blank">上传页面</a> 页面中上传视频 获取视频识别码填入此项中
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-for="group in route.slider" track-by="$index">
      <div class="page-header">
        <span class="glyphicon glyphicon-paperclip"></span>
        {{text[group.location]}}
        <button
          type="button"
          class="btn btn-success btn-xs"
          @click="group.images.push({
            pic: '',
            title: ''
          })"
        >添加</button>
        <button class="close hidden" type="button">&times;</button>
      </div>
      <div class="form-group d-flex" v-d-sortable="group.images">
        <div class="col-xs-6" v-for="item in group.images" track-by="$index">
          <div>
            <button type="button" class="close" @click="group.images.$remove(item)">&times;</button>
          </div>
          <div class="media l-media">
            <div class="media-left l-media-left">
              <d-upload :url.sync="item.pic" class="btn btn-primary btn-block btn-xs">
                <span v-if="group.location === 'vertical'">上传 75:83 比例</span>
                <span v-else>上传图片 16:9</span>
              </d-upload>
              <img class="img-responsive" v-show="item.pic" :src="item.pic" alt />
            </div>
            <div class="media-body">
              <textarea id cols="30" rows="5" class="form-control" v-model="item.title"></textarea>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" @click="click(submit)($event, '/routes')" class="btn btn-primary">保存</button>
      </div>
    </div>
  </form>
</template>

<script>
import dUpload from '../../components/Upload'
import config from '../../libs/config'
import utils from '../../libs/utils'
import _ from 'lodash'

export default {
  props: {
    route: {
      coerce (route) {
        let keys = ['top', 'vertical', 'bottom']
        route.slider = _.uniqBy(route.slider, 'location')

        keys.forEach((key) => {
          if (!_.some(route.slider, ['location', key])) {
            route.slider.push({
              type: 'route',
              location: key,
              images: []
            })
          }
        })
        return route
      }
    }
  },
  data () {
    return {
      xmenProductUrl: process.env.XMEN_PRODUCT_URL,
      list: [],
      text: {
        top: '三级页面PC轮播图',
        vertical: '三级页面手机轮播图',
        bottom: '回顾图'
      }
    }
  },
  components: {
    dUpload
  },
  methods: {
    submit () {
      let data = {
        parentId: this.$route.params.id,
        sliders: this.route.slider,
        videoId: this.route.basic.videoId,
        videoCoverPath: this.route.basic.videoCoverPath
      }
      return this.$http.put(`${config.apiWe}/product/route/${this.$route.params.id}/slider`, data)
      .then(
        // this.$route.router.go('/routes')
        window.alert('保存成功')
      )
    },
    removeVideoCoverPath () {
      this.route.basic.videoCoverPath = ''
    },
    click: utils.click
  }
}
</script>

<style>
.l-media {
  margin-bottom: 20px;
}
.l-media-left {
  width: 50%;
}
</style>



/** WEBPACK FOOTER **
 ** Images.vue?4e06b1bc
 **/